import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DiseaseModel } from '../../models'

export interface DiseaseState {
    Disease: DiseaseModel
    DiseaseList: DiseaseModel[]
}

const initialState: DiseaseState = {
    Disease: {} as DiseaseModel,
    DiseaseList: [],
}

export const DiseaseSlice = createSlice({
    name: 'disease',
    initialState,
    reducers: {
        setDiseases: (state, action: PayloadAction<DiseaseModel[]>) => {
            state.DiseaseList = action.payload
        },
        saveDisease: (state, action: PayloadAction<DiseaseModel>) => {
            let model = action.payload
            if (model.Id > 0) {
                let defaultModel: DiseaseModel = {
                    Id: model.Id,
                    DiseaseName: model.DiseaseName,
                }

                let currentDisease =
                    state.DiseaseList.find((c) => c.Id === model.Id) || defaultModel
                currentDisease.DiseaseName = model.DiseaseName
            } else {
                model.Id = (Math.max(...state.DiseaseList.map((c) => c.Id)) || 0) + 1
                state.DiseaseList.push(model)
            }
        },
        getDiseaseById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let category: DiseaseModel = {} as DiseaseModel
            if (id > 0) {
                let currentCategories: DiseaseModel[] = state.DiseaseList
                category = currentCategories.find((c) => c.Id === id) || ({} as DiseaseModel)
            }

            state.Disease = category
        },
        deleteDiseases: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentCategories: DiseaseModel[] = state.DiseaseList
                state.DiseaseList = currentCategories.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setDiseases, saveDisease, getDiseaseById, deleteDiseases } = DiseaseSlice.actions

export default DiseaseSlice.reducer
